module.exports = __webpack_public_path__ + "static/media/bentley.a9b22b7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/bentley.svg
// module id = 585
// module chunks = 0